export default function usePermissions() {
    const hasPermission = (permissions, permission) => {
        if (Array.isArray(permission)) {
            return permission.every(p => permissions.includes(p));
        } else {
            return permissions?.hasOwnProperty(permission) && permissions[permission] === true;
        }
    };

    return {
        hasPermission,
    };
}
